export enum OperationMode {
  CREATE = <any> 'A',
  EDIT = <any> 'E',
  VIEW = <any> 'V'
}
